module.exports = __webpack_public_path__ + "static/img/recruit_2021_logo.12f2c02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/info/recruit_2021_logo.png
// module id = IEH7
// module chunks = 0